<template>
  <div class="kefu-float" v-drag>
    <div class="kefu-main" @click.stop="goService">
      <div class="kefu-icon"
        :style="onlineServiceLists?.[0] ? `background-image: url(${onlineServiceLists?.[0]?.['avatar']});` : null">
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref } from 'vue';
import { useHot } from '/@/kernel-mn/stores/useHot';
// import { getServiceList } from '/@/hooks/userActions';
import { useRouter } from 'vue-router';
import { isApp } from '/@/kernel-mn/utils';
import { mb_RNEvent } from '/@/plugins/global';
import { checkIsLinks } from "/@/hooks/publicData.ts";

export default {
  name: 'KefuLayOut',
  emits: [],
  // eslint-disable-next-line no-unused-vars
  setup() {
    const { hotData } = useHot();
    const router = useRouter();
    let { isLogined, userInfo } = hotData;
    let onlineServiceLists: any = ref([]);
    // getServiceList().then(res => {
    //   onlineServiceLists.value = res || [];
    // });
    // 跳转方法
    const gotourl = url => {
      let isapp = isApp();
      let newTab = null;
      !isapp && (newTab = window.open('about:blank'));
      if (isapp) {
        mb_RNEvent.sendNativeMsg('url:' + url);
      } else {
        newTab.location.href = url;
      }
    };
    const goService = () => {
      // 用户有登录 代理返点有配置客服链接 则用这个
      if (isLogined.value && userInfo.value.partner && userInfo.value.partner.kf_url) {
        let kf_url = userInfo.value.partner.kf_url;
        // 是链接就直接跳转
        gotourl(kf_url);
      } else {
        if (onlineServiceLists.value.length) {
          const item = onlineServiceLists.value[0]
          if (checkIsLinks(item.numOrConnect)) {
            // 是链接就直接跳转
            gotourl(item.numOrConnect);
          } else {
            router.push('/service')
          }
        } else {
          router.push('/service')
        }
      }
    }
    return {
      onlineServiceLists,
      goService,
    };
  }
};
</script>
<style lang="scss" scoped>
.kefu-float {
  position: fixed;
  left: calc(100vw - #{px2rem(60)});
  top: calc(100% - #{px2rem(140)});
  z-index: 99;

  .kefu-icon {
    width: px2rem(46);
    height: px2rem(46);
    @include bgFull(publicImgUrl('services/kefu_float.png'));
  }
}
</style>
